import { UiButtonBase, UiTypography } from "@smp/ui";
import clsx from "clsx";

import { useStyles } from "./filter_option_button.css";

export const FilterOptionButton = ({
  isActive,
  value,
  title,
  onChange,
}: {
  isActive: boolean;
  value: string;
  title: string;
  onChange: (option: string) => void;
}) => {
  const classes = useStyles();

  const handleClick = () => {
    onChange(value);
  };

  return (
    <UiButtonBase
      onClick={handleClick}
      className={clsx(classes.button, {
        [classes["button--active"]]: isActive,
      })}
    >
      <UiTypography variant="h6">{title}</UiTypography>
    </UiButtonBase>
  );
};
